import React from 'react';
import { add } from 'date-fns';
import { StyledDeviceActivationCode, StyledTimerSpan } from './DeviceActivationCode.styles';
import { useCountdown } from '../../../helpers/useCountDown';
import { BiSolidHide, BiSolidShow } from 'react-icons/bi';
import { RxReload } from 'react-icons/rx';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from '../../../Context/authContext';

function DeviceActivationCode({ code, targetDate, handelOtpShow, regenrateOtp, rowID, data }) {
  //   const [isVisible, setIsVisible] = useState(false);
  const [minutes, seconds] = useCountdown(add(targetDate, { minutes: 5 }));

  const { hasPermission } = useContextHook(AuthContext, v => ({
    hasPermission: v.hasPermission,
  }));

  return minutes <= 0 && seconds <= 0 ? (
    <>
      <span>Expired</span>
      {hasPermission('device.revoke') && data?.status !== 'Deactivated' && (
        <RxReload size={18} color="#355B85" onClick={regenrateOtp} cursor="pointer" />
      )}
    </>
  ) : (
    <StyledDeviceActivationCode>
      <div className="otp-text">{rowID === data?.serial_number ? data?.activation_code?.otp : '******'}</div>
      <StyledTimerSpan>
        {`(${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds})`}
      </StyledTimerSpan>
      <div className="toggleIcon" onClick={handelOtpShow}>
        {rowID === data?.serial_number ? (
          <BiSolidShow size={22} color="#000" />
        ) : (
          <BiSolidHide size={22} color="#000" />
        )}
      </div>
    </StyledDeviceActivationCode>
  );
}

export default DeviceActivationCode;
